import withAnimation from './withAnimation';

export default withAnimation;

export type {
  CloseAnimation,
  withAnimationProps,
  withAnimationState,
} from './withAnimation';
